import { render } from "./InfoRowStudyTask.vue?vue&type=template&id=579d84b6&scoped=true"
import script from "./InfoRowStudyTask.vue?vue&type=script&lang=js"
export * from "./InfoRowStudyTask.vue?vue&type=script&lang=js"

import "./InfoRowStudyTask.vue?vue&type=style&index=0&id=579d84b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579d84b6"]])

export default __exports__